import React from "react";
import { useLocation } from "react-router-dom";
import Content from "../pages/lawLibrary/Content";
import Index from "../pages/lawLibrary/Index";

function DocumentRouter() {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const subdocumentId = queryParams.get("subdocumentId");
  const documentId = queryParams.get("documentID");

  if (subdocumentId) {
    return <Content subdocumentId={subdocumentId} />;
  } else if (documentId) {
    return <Index documentId={documentId}/>;
  } else {
    return <div>Invalid URL parameters</div>; // Optional: handle missing params
  }
}

export default DocumentRouter;
